var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.enterprise)?_c('div',{staticClass:"s-vstack"},[_c('Locations',{attrs:{"bizs":_vm.bizs},on:{"saved":function($event){return _vm.loadBizs()}}}),_c('Regions',{attrs:{"bizs":_vm.bizs}}),_c('Chains')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }